import {Component, OnDestroy} from '@angular/core';
import { CustomAlert} from "../../../../shared/interfaces/alert";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {TemplateAlertComponent} from "../../../template-alert/template-alert.component";
import {AlertService} from "../../../../services";
import { Subscription, timer} from "rxjs";

@Component({
  selector: 'custom-alert',
  standalone: true,
  imports: [
  ],
  template: '',
  providers: [DialogService]
})
export class CustomAlertComponent implements OnDestroy {
  private TIMER:number = 5_000;
  config!: CustomAlert;
  defaultConfig!: CustomAlert;
  private _showSubscription: Subscription | undefined;
  private onCloseSubscription: Subscription | undefined;
  private ref: DynamicDialogRef  | undefined;

  constructor(public dialogService: DialogService, private service: AlertService) {
    this._showSubscription =  this.service.showSource$.subscribe($event => {
      this.show($event)
    });
    this.default();

  }

  private default() {
    this.defaultConfig = {
      closable: false,
      breakpoints: {
        '2000px':'35vw',
        '1900px': '37vw',
        '1700px': '40vw',
        '1400px': '45vw',
        '960px': '75vw',
        '640px': '90vw'
      },
      modal: true,
      styleClass: 'alert'
    }
  }

  show(config: any) {
    if (config && 'icon' in config) {
      this.config = this.defaultConfig;
      this.config.data = config;
    }else{
      let input = config as CustomAlert;
      this.config = {
        closable: input.closable ?? this.defaultConfig.closable,
        breakpoints: input.breakpoints ?? this.defaultConfig.breakpoints,
        modal: input?.modal ?? this.defaultConfig.modal,
        styleClass:input?.styleClass ?? this.defaultConfig.styleClass,
        data : input.data,
        autoClose: input.autoClose,
        timer: input.timer,
        position: input.position ?? 'center',
      }
    }
    this.ref = this.dialogService.open(TemplateAlertComponent, this.config);
    if (this.config.autoClose) {
      const time = this.config.timer || this.TIMER;
      timer(time).subscribe(val => {
        this.service.hide({accept:true})
        this.clean();
      })
    }
    this.ref?.onClose.subscribe(val=>{
      this.service.hide(val);
    })
  }

  ngOnDestroy(): void {
     if (this._showSubscription) this._showSubscription.unsubscribe();
    if (this.onCloseSubscription) this.onCloseSubscription.unsubscribe();
  }

  hide() {
      this.ref?.close();
      this.clean();
  }

  private clean(){
    this.ref?.destroy();
    if (this.onCloseSubscription) this.onCloseSubscription.unsubscribe();
    this.ref =undefined;
  }


}
